import type {
  FileListConfig,
  VirtualSpaceBlockRow,
} from "@/lib/virtualspace/virtual-space-types";

/**
 * True when a public `file_list` has at least one resolved file the
 * customer can see. Empty curated lists and unresolved ids stay off
 * the share — "No files attached yet" is editor copy, not customer UI.
 */
export function fileListBlockHasCustomerFiles(
  config: FileListConfig,
  assets: Record<string, unknown>,
): boolean {
  const ids = config.file_asset_ids ?? [];
  return ids.some((id) => Boolean(id) && assets[id] != null);
}

export function omitEmptyPublicFileListBlocks<T extends VirtualSpaceBlockRow>(
  blocks: readonly T[],
  assets: Record<string, unknown>,
): T[] {
  return blocks.filter((block) => {
    if (block.block_type !== "file_list") return true;
    return fileListBlockHasCustomerFiles(
      block.config as FileListConfig,
      assets,
    );
  });
}
